<template>
  <div>
    <b-modal
      id="modal-multi-2"
      title="Forgot Password"
      ok-only
      @ok.prevent="requestReset"
    >
      <label for="emailinput">Enter your email here.</label>
      <b-form-input
        id="emailinput"
        v-model="email"
        type="email"
        v-validate="'required|email'"
        placeholder="Enter your email"
        name="email"
        :class="{ 'is-invalid': errors.has('email') }"
        v-on:keyup.enter="requestReset"
      ></b-form-input>
      <b-form-invalid-feedback id="input-3-live-feedback">
        <small>{{ errors.first("email") }}</small>
      </b-form-invalid-feedback>
    </b-modal>
    <b-modal id="modal-multi-3" title="Forgot Password" ok-only>
      <small>{{ message }}</small>
    </b-modal>
  </div>
</template>

<script>
import { authenticationApi } from "../../services/authenticationApi";

export default {
  name: "ForgotModal",
  data() {
    return {
      email: "",
      ShowReset: false,
      message: ""
    };
  },
  methods: {
    requestReset() {
      this.$validator.validate("email").then(result => {
        if (result) {
          this.ShowReset = false;
          const emailid = {
            email: this.email
          };
          this.$bvModal.hide("modal-multi-2");
          authenticationApi
            .requestPassword(emailid)
            .then(res => {
              this.email = "";
              this.message = "We will send a Reset link to this email";
              this.$bvModal.show("modal-multi-3");
            })
            .catch(e => {
              this.email = "";
              this.message = "Provided Email is not Registered";
              this.$bvModal.show("modal-multi-3");
            });
        } else {
          this.showReset = true;
        }
      });
    }
  }
};
</script>

<style scoped></style>
